var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"os-icon"},[_c('div',{staticClass:"os-element"},[_c('span',{staticClass:"os-system"},[_vm._v("win")]),_c('span',{staticClass:"os-version"},[_vm._v(" "+_vm._s(_vm.version())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }